const LIST_QUERY = `
  query ListAccessEvents($paginationParams: PaginationInput!,
      $fromDate: DateTime,
      $toDate: DateTime
    ) {
    listAccessEvents(pagination: $paginationParams,
      fromDate: $fromDate,
      toDate: $toDate) {
      objects {
        initiatedAt
        deviceName
        isAccessGranted
        accessMode
        transactions {
          username
          firstName
          lastName
          credentialType
          requireStepUp
          isComplete
          isValid
          createdAt
        }
        deviceEvents {
          deviceEventAt
          deviceName
          deviceSerialNumber
          eventType
          additionalData {
            admins {
              username
              firstName
              lastName
            }
          }
        }
      }
      totalRows
    }
  }
`

const CSV_QUERY = `
  query listAccessEventsAsCSV($fromDate: DateTime, $toDate: DateTime) {
    listAccessEventsAsCSV(fromDate: $fromDate, toDate: $toDate) {
      csv
    }
  }
`

const accessEventQueries = {
  methods: {
    async listAccessEventsQuery(paginationParams, filterDates) {
      try {
        const result = await this.graphQuery(LIST_QUERY, {
          paginationParams,
          ...filterDates,
        })
        return {
          accessEvents: result.listAccessEvents.objects,
          totalRows: result.listAccessEvents.totalRows,
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async getAccessEventsAsCSV(filterDates) {
      try {
        const result = await this.graphQuery(CSV_QUERY, {...filterDates})
        return result.listAccessEventsAsCSV.csv
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default accessEventQueries
